module.exports = __webpack_public_path__ + "static/projectsbg-36745bcb886a604e3fa4d3078c93889d.png";